import { useEffect, useState } from "react";

/** `value`, once it has stopped changing for `delay` ms. */
export const useDebouncedValue = <T>(value: T, delay = 350): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};
